import React from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import styles from '../orderInfo/styles';

const LBS_PER_KG = 2.20462262;
const formatWeightForDisplay = (weightLbs, unit) => {
  if (weightLbs === '' || weightLbs == null) return '';
  const lbs = Number(weightLbs);
  if (Number.isNaN(lbs)) return `${weightLbs} lb`;
  if (unit === 'kg') return `${Math.round((lbs / LBS_PER_KG) * 100) / 100} kg`;
  return `${lbs} lb`;
};

const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return 'N/A';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'CAD' }).format(amount);
};

const OrderSummary = ({ packageSize, packageImage, pieces, pieceDescriptionOverride, weight, weightUnit, tripRate, returnRate }) => {
  const totalRate = Number(tripRate || 0) + Number(returnRate || 0);

  return (
    <div style={styles.orderContainer}>
      <Grid container direction="row" alignItems="stretch" spacing={2}>

        <Grid item xs={12}>
          <Typography style={styles.sectionTitle}>ORDER SUMMARY</Typography>
        </Grid>

        {/* Package card */}
        <Grid item xs={12}>
          <div style={styles.packageCard}>
            <div style={styles.packageImageBlock}>
              {packageImage && (
                <img src={packageImage} alt="Package type" style={styles.packageImage} />
              )}
              <Typography style={styles.packageSizeLabel}>{packageSize}</Typography>
            </div>
            <Divider orientation="vertical" flexItem style={{ margin: '0 16px' }} />
            <div style={styles.packageStats}>
              <div style={styles.packageStat}>
                <Typography style={styles.packageStatLabel}>
                  {(pieceDescriptionOverride || 'Pieces').toUpperCase()}
                </Typography>
                <Typography style={styles.packageStatValue}>{pieces}</Typography>
              </div>
              <div style={styles.packageStat}>
                <Typography style={styles.packageStatLabel}>WEIGHT</Typography>
                <Typography style={styles.packageStatValue}>
                  {formatWeightForDisplay(weight, weightUnit)}
                </Typography>
              </div>
            </div>
          </div>
        </Grid>

        {/* Rate cards */}
        {[
          { label: 'TRIP RATE',   value: formatCurrency(tripRate) },
          { label: 'RETURN RATE', value: formatCurrency(returnRate) },
          { label: 'TOTAL RATE',  value: formatCurrency(totalRate) },
        ].map(({ label, value }) => (
          <Grid item xs={12} sm={4} key={label}>
            <div style={styles.addressCard}>
              <Typography style={styles.addressCardLabel}>{label}</Typography>
              <Divider style={{ marginBottom: 6 }} />
              <Typography style={styles.addressCardName}>{value}</Typography>
            </div>
          </Grid>
        ))}

      </Grid>
    </div>
  );
};

export default OrderSummary;
